import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassportDetailsComponent } from '../passport-details/passport-details.component';
import { Router } from '@angular/router';
import { PassportDetailsStore } from '../shared/passport-details.store';
import { UiStateService } from '../shared/ui-state.service';
import { BasePassportCellComponent } from '../shared/base-passport-cell.component';

@Component({
  selector: 'app-gatehouse-passport-cell',
  standalone: true,
  imports: [CommonModule, PassportDetailsComponent],
  templateUrl: '../shared/passport-cell.template.html',
  styleUrl: './gatehouse-passport-cell.component.css'
})
export class GatehousePassportCellComponent extends BasePassportCellComponent {
  protected get personaName(): string {
    return 'gatehouse';
  }

  constructor(router: Router, details: PassportDetailsStore, ui: UiStateService) {
    super(router, details, ui);
  }

  /**
   * Override to set variety as empty string for gatehouse
   */
  protected override createPassportHeader() {
    return {
      loadNumber: this.loadNumber,
      variety: '', // Gatehouse doesn't use variety
      haulier: this.haulier,
      bulkerNumber: this.bulkerNumber,
      scheduledText: this.scheduledText,
      origin: this.origin,
      destination: this.destination,
      apnName: this.apnName,
      vendorName: this.vendorName,
      vendorNumber: this.vendorNumber
    };
  }

  /**
   * Override metaItems to exclude variety for gatehouse
   */
  override get metaItems() {
    return [
      { icon: '/assets/images/Grower_Icon.png', alt: 'Grower', cssClass: 'grower', value: this.vendorName },
      { icon: '/assets/images/Bulker_Icon.png', alt: 'Bulker', cssClass: 'bulker', value: this.bulkerNumber }
    ];
  }
}


